import { IngredientsGenerator } from "../Components/Icons";

const obj = {

  title: "Ingredients Generator",
  desc: "Provide a meal name and description and get the list of ingredients required to make it",
  category: "Meal Planning",
  Icon: IngredientsGenerator,
  // tags: [],
  permissions: ["user"],

  fromColor: "gray-500",
  toColor: "gray-500",

  to: "/ai/ingredients",
  api: "/ai/ingredients",

  output: {
    title: "Ingredient List",
    desc: "Please be patient while we generate your ingredients. Depending on usage it could take up to 1 minute",
    // Icon: RefreshIcon,
    // color: "",
},

  video:
    "https://mealpalaivideos.s3.ap-southeast-2.amazonaws.com/Ingredients_generator.mp4",
    prompts: [{

      title:"Ingredients",
      desc: "Please provide your ingredients and other key information below",
      // n: 1,
      prompts: [
          { 
              title: "Meal Description", 
              attr: "mealdesc",  
              value: "", 
              placeholder: "e.g Chicken Thighs with Cauliflower Rice: Marinate chicken thighs with herbs, spices, and olive oil, then bake in the oven. Serve with a side of riced cauliflower mixed with herbs and spices for a filling, low-carb meal. ", 
              // label: "Examples: breakfast, lunch, dinner, snack",
              // type: "textarea",
              maxLength: 300,
              // max: 100,
              // min: 5,
              required: true,
              error: "",
              example: "Turkey Burger with Sweet Potato Fries: Turkey burger served with a side of sweet potato fries. The turkey provides a lean source of protein, while the sweet potatoes offer complex carbohydrates to help replenish glycogen stores.",
          },
          { 
              title: "Units", 
              attr: "units",  
              value: "", 
              placeholder: "e.g metric or imperial", 
              // label: "Examples: breakfast, lunch, dinner, snack",
              // type: "textarea",
              maxLength: 50,
              // max: 100,
              // min: 5,
              required: false,
              error: "",
              example: "Metric",
          },
          { 
              title: "Dietary requirements", 
              attr: "dietary",  
              value: "", 
              placeholder: "e.g vegan, anaphylactic to nuts, ketogenic diet", 
              label: "",
              type: "textarea",
              maxLength: 100,
              // max: 100,
              // min: 1,
              required: false,
              error: "",
              example: "N/A"
          },
          { 
              title: "Fitness Goals", 
              attr: "goals",  
              value: "", 
              placeholder: " e.g weight loss, muscle gain, maintenance, athlete", 
              label: "",
              type: "textarea",
              maxLength: 100,
              // max: 100,
              // min: 1,
              required: false,
              error: "",
              example: "Body builder"
          },
          { 
              title: "Approx Calories per serve", 
              attr: "calories",  
              value: "", 
              placeholder: "e.g 500", 
              // label: "Examples: breakfast, lunch, dinner, snack",
              // type: "textarea",
              maxLength: 50,
              // max: 100,
              // min: 5,
              required: false,
              error: "",
              example: "1500",
          },
          { 
              title: "Servings", 
              attr: "servings",  
              value: "", 
              placeholder: "e.g 4 servings, 10 servings", 
              // label: "Examples: breakfast, lunch, dinner, snack",
              // type: "textarea",
              maxLength: 50,
              // max: 100,
              // min: 5,
              required: true,
              error: "",
              example: "3 servings",
          },
          { 
              title: "Complexity", 
              attr: "complexity",  
              value: "", 
              placeholder: "e.g keep as simple as possible, make everything from scratch", 
              label: "",
              type: "textarea",
              maxLength: 100,
              // max: 100,
              // min: 1,
              required: false,
              error: "",
              example: "Keep it simple"
          },
          { 
              title: "Budget", 
              attr: "budget",  
              value: "", 
              placeholder: "e.g keep costs down, spare no expense", 
              label: "",
              type: "textarea",
              maxLength: 100,
              // max: 100,
              // min: 1,
              required: false,
              error: "",
              example: "No budget"
          },

      ],
      example: {
output: `INGREDIENT LIST: TURKEY BURGER WITH SWEET POTATO FRIES

For the Turkey Burgers:

3 lbs ground turkey
1/2 cup breadcrumbs
1 egg
1/2 cup diced yellow onion
1/4 cup diced bell pepper
1 tsp garlic powder
1 tsp salt
1 tsp black pepper

For the Sweet Potato Fries:

3 large sweet potatoes, cut into matchsticks
2 tbsp vegetable oil
1/2 tsp garlic powder
1/2 tsp paprika
1/2 tsp salt
1/2 tsp black pepper`,
          // outputs: [],
          // Icon: RefreshIcon,
          // color: "",
      }
  }]
      
}

export default obj